// extracted by mini-css-extract-plugin
export default {"arrowLeft":"AgluQk","arrowRight":"mXrOdj"};